import cookieSettingsView from './cookieSettingsComponent.html';
import './cookieSettingsComponent.css';

export function cookieSettingsComponent() {
	return {
		bindings: {},
		controllerAs: 'vm',
		controller: cookieSettingsComponentCtrl,
		template: cookieSettingsView,
	};
}

export class cookieSettingsComponentCtrl {
	constructor(Cookies) {
		'ngInject';
		this.Cookies = Cookies;
	}

	cookieSliderClick(evt) {
		this.Cookies.updateOptionalConsent(evt.target.checked);
	}
}
